import { HomeCarouselCount } from '@/components/common/organism/HomeCarousel';
import { useState } from 'react';
import styled from '@emotion/styled';
import CardListCarousel from '@/components/common/organism/CardListCarousel';
import SectionHeader from '@/pages/HomeV2/sections/SectionHeader';
import type { RecruitmentListData } from './types';

export const RecruitmentCarouselPageIndicator = styled.div`
    font-size: 0.875rem;
    color: #6b7280;
    font-weight: 500;
    margin-right: 2px;

    @media (min-width: 769px) {
        display: none;
    }
`;

const DesktopCount = styled(HomeCarouselCount)`@media (max-width: 768px) { display: none; }`;

interface PremiumRecruitmentSectionProps {
    data: RecruitmentListData[];
    title?: string;
    onCardClick: (id: number) => void;
    /** 홈에서만 전체보기로 이동한다. 현재 목록에서는 조건을 유지하며 생략한다. */
    onMoreClick?: () => void;
    /** 목록 조건이 바뀌면 같은 공고 수여도 첫 장으로 돌아간다. */
    resetKey?: string;
    /** 채용 목록 PC에서만 일반 카드 그리드와 폭·간격을 맞춘다. */
    desktopGridAligned?: boolean;
    homeControls?: boolean;
}

/** 홈과 채용 목록이 같은 제목·카드 구성을 사용한다. 데이터 조회와 바깥 여백은 각 화면이 관리한다. */
const PremiumRecruitmentSection = ({ data, title = '오늘의 채용', onCardClick, onMoreClick, resetKey, desktopGridAligned = false, homeControls = false }: PremiumRecruitmentSectionProps) => {
    const [page, setPage] = useState(1);
    const [desktopPage, setDesktopPage] = useState({ page: 1, total: 1 });
    const pageCount = Math.ceil(data.length / 2);
    if (data.length === 0) return null;

    return (
        <>
            <SectionHeader
                title={title}
                onMoreClick={onMoreClick}
                meta={<>{pageCount > 1 && <RecruitmentCarouselPageIndicator>{page} / {pageCount}</RecruitmentCarouselPageIndicator>}{homeControls && desktopPage.total > 1 && <DesktopCount aria-live="polite">{desktopPage.page} / {desktopPage.total}</DesktopCount>}</>}
            />
            <CardListCarousel
                type="contents"
                data={data}
                onClick={onCardClick}
                rowLength={4}
                arrowButton
                mobileRows={1}
                mobileFullWidthSingle
                onPageChange={setPage}
                resetKey={resetKey}
                desktopGridAligned={desktopGridAligned}
                homeControls={homeControls}
                onDesktopPageChange={(page, total) => setDesktopPage(current => current.page === page && current.total === total ? current : { page, total })}
            />
        </>
    );
};

export default PremiumRecruitmentSection;
